import { t } from '../../i18n';
import { createActionButton } from './domFactories';
import type { DungeonOption } from './types';

interface RenderDungeonsTabParams {
    list: HTMLDivElement;
    dungeons: ReadonlyArray<DungeonOption>;
    enteringDungeonId: string | null;
    onEnter: (dungeonId: string) => void;
}

export function renderDungeonsTab(params: RenderDungeonsTabParams): void {
    const { list, dungeons, enteringDungeonId, onEnter } = params;

    const helper = document.createElement('div');
    helper.textContent = t('userMenu.dungeons.choose');
    Object.assign(helper.style, {
        color: '#9ca3af',
        textAlign: 'center',
        marginBottom: '12px',
    });
    list.appendChild(helper);

    if (dungeons.length === 0) {
        const empty = document.createElement('div');
        empty.textContent = t('userMenu.dungeons.noneAvailable');
        Object.assign(empty.style, { textAlign: 'center', color: '#6b7280', marginTop: '20px' });
        list.appendChild(empty);
        return;
    }

    dungeons.forEach(({ id, name }) => {
        const button = createActionButton(name, '#2563eb');
        Object.assign(button.style, { width: '100%', justifyContent: 'center' });
        button.disabled = enteringDungeonId !== null;
        button.textContent = enteringDungeonId === id ? t('userMenu.dungeons.entering', { name }) : name;
        button.addEventListener('click', () => {
            onEnter(id);
        });
        list.appendChild(button);
    });
}
